import Button from '@brands/Components/Button/Button';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { selectAuth } from '@brands/store/selectors/auth';
import {
  getPatientReviewProfileRoleSegment,
  getStaffReviewProfileBasePath,
  isStaffCaseCreationRole,
} from '@brands/Utils/reviewProfileBasePath';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import CloseIcon from '@mui/icons-material/Close';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './dashboardModal.module.scss';

type UnavailableTimeSlotModalType = {
  setDisplayUnavailableTimeSlotModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const UnavailableTimeSlotModal: React.FC<UnavailableTimeSlotModalType> = ({ setDisplayUnavailableTimeSlotModal }) => {
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const { userInfo } = useAppSelector(selectAuth);
  const goToDashboard = useCallback(() => {
    if (isStaffCaseCreationRole(userInfo.role.name)) {
      navigate(
        `${getStaffReviewProfileBasePath(userInfo.role.name)}/${getPatientReviewProfileRoleSegment(
          currentPatient,
        )}/${currentPatient.id}`,
      );
    } else {
      roleNavigate('/dashboard');
    }
  }, [userInfo.role.name, navigate, roleNavigate, currentPatient]);
  return (
    <div className={styles.modalBackground} onClick={() => setDisplayUnavailableTimeSlotModal(false)}>
      <div
        className={`${styles.modalContainer} ${styles.submitConfirmationModal} ${styles.unavailableTimeSlot} fs-unmask`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.modalCloseIcon}>
          <button type="button" onClick={() => goToDashboard()} aria-label="Close modal">
            <CloseIcon />
          </button>
        </div>
        <div className={styles.body}>
          <p>Time Slot Unavailable</p>
          <span>
            It looks like the time slot you selected is no longer available. Please choose a new time to complete your
            appointment.
          </span>
          <Button
            className={styles.selectNewTimeSlot}
            onClick={() =>
              roleNavigate('/select-provider', {
                state: {
                  isFromUnavailableTimeSlotModal: true,
                },
              })
            }
          >
            Select a time slot
          </Button>
        </div>
      </div>
    </div>
  );
};
export default UnavailableTimeSlotModal;
